import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { ToolModeToggle } from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { URLDecode, URLEncode } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function URLencoder() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'URL Encoder/Decoder', Iconpath: "/link.svg" };
    const [mode, setMode] = useState("encode");


    


    useEffect(() => {
        setText("")
        setresult("")
    }, [mode]);

    



    const lineCount = (text || "").split("\n").length;
    const resultLineCount = (result ?? "").toString().split("\n").length;

    const handleChange = async (e) => {
        const value = e.target.value;
        setText(value);
    };

    const Execute = async () => {
         if(text.trim() === "") {
            setresult("");
            return;
        }
        getResult(text);
    }
    const getResult = async (value) => {
        if (mode === "encode") {
            try {
                const response = await URLEncode({ input: value });
                setresult(response.data.encoded);
            }
            catch (error) {
                console.error("Error encoding URL:", error.response?.data?.message);
                setresult(error.response?.data?.message || "Error encoding URL.");
            }
        } else {
            try {
                const response = await URLDecode({ input: value });
                setresult(response.data.decoded);
            }
            catch (error) {
                console.error("Error decoding URL:", error.response?.data?.message);
                setresult(error.response?.data?.message || "Error decoding URL.");
            }
        }
    };

    const importFile = (fileContent) => {
        setText(fileContent);
    }

    const pasteExample = () => {
        let exampleValue = "";

        if (mode === "encode") {
            exampleValue = "Hello World";
        } else {
            exampleValue = "Hello+World%21";
        }

        setText(exampleValue);
    };

    return (
        <>
            <Col>
                <ToolHeader title="URL Encoder/Decoder" description="Encode text into URL-safe format or decode URL-encoded strings back to readable text for web and query parameter handling" toolFav={toolFav} />

                <ToolModeToggle
                    options={[
                        { label: "Encode", value: "encode", className: "encode" },
                        { label: "Decode", value: "decode", className: "decode" }
                    ]}
                    activeValue={mode}
                    onChange={setMode}
                />
                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder={mode === "encode" ? "Paste text to encode.." : "Paste text to decode.."}
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    executeLabel={mode === "encode" ? "Encode" : "Decode"}
                                    showExecute={true}
                                    onExecute={Execute}
                                    onImport={(fileContent) => importFile(fileContent)}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Output"
                            value={result ?? ""}
                            placeholder="Output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={`${mode === "encode" ? "url-encode" : "url-decode"}.txt`}
                                    mimeType="text/plain;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default URLencoder;
